import { render, staticRenderFns } from "./RecentQuotes.vue?vue&type=template&id=110eb1ac&scoped=true"
import script from "./RecentQuotes.vue?vue&type=script&lang=js"
export * from "./RecentQuotes.vue?vue&type=script&lang=js"
import style0 from "./RecentQuotes.vue?vue&type=style&index=0&id=110eb1ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110eb1ac",
  null
  
)

export default component.exports